/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Row,
  Spin,
  Col,
} from 'antd';
import Table from 'components/Table';
import currencyFormatter from 'utils/currencyFormatter';
import PercentageInput from 'components/PercentageInput';
import CurrencyInput from 'components/CurrencyInput';
import { getPercepciones } from 'api/nominas/percepciones/percepciones';
import { checkToken } from 'api/utils';
import { ESTATUS_AUTORIZADO } from 'utils/constants';
import percentFormatter from 'utils/percentFormatter';
import percentFormatterNDecimals from 'utils/percentFormatterNdecimals';

const NominasISN = ({ data, encabezado }) => {
  const [loading, setLoading] = useState(false);
  const [percepciones, setPercepciones] = useState([]);

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _percepciones,
      ] = await Promise.all([
        getPercepciones(),
      ]);
      if (mounted) {
        setPercepciones(_percepciones);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const totalGravado = data?.reduce((acc, curr) => acc
    + (parseFloat(curr.importe_isn_gravado) || 0), 0) || 0;

  const columns = [
    {
      titleText: 'Concepto',
      dataIndex: 'percepcion',
      key: 'percepcion',
      width: 200,
      render: (val) => {
        const _percepcion = percepciones.find((e) => e.id === val);
        return `${_percepcion?.clave} - ${_percepcion?.descripcion}`;
      },
    },
    {
      titleText: 'Importe',
      dataIndex: 'importe',
      key: 'importe',
      width: 200,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Exento',
      dataIndex: 'importe_isn_excento',
      key: 'importe_isn_excento',
      width: 200,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Gravado',
      dataIndex: 'importe_isn_gravado',
      key: 'importe_isn_gravado',
      width: 200,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
  ];
  const columnsSubsidios = [
    {
      titleText: 'Base Gravable',
      dataIndex: 'importe_isn_base_gravable',
      key: 'importe_isn_base_gravable',
      width: 200,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Tasa de ISN',
      dataIndex: 'tasa_de_isn',
      key: 'tasa_de_isn',
      width: 200,
      align: 'right',
      render: (val) => percentFormatter(val || 0),
    },
    {
      titleText: 'ISN Causado',
      dataIndex: 'importe_isn_causado',
      key: 'importe_isn_causado',
      width: 200,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
  ];
  const summaryCells = [
    {
      // Columna 1: Concepto (Texto 'Total')
      value: 'Total',
      valueAlign: 'left',
      render: (val) => <strong>{val}</strong>,
    },
    {
      // Columna 2: Importe (Espacio vacío)
      value: null,
      render: () => '',
    },
    {
      // Columna 3: Exento (Espacio vacío)
      value: null,
      render: () => '',
    },
    {
      // Columna 4: Gravado (Total calculado)
      value: totalGravado,
      valueAlign: 'right',
      render: (val) => currencyFormatter(val),
    },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          allowExportPDF={false}
          summaryCells={summaryCells}
        />
      </Spin>
      <Table
        cols={columnsSubsidios}
        data={[encabezado]}
        allowExportPDF={false}
      />
    </Row>
  );
};

export default NominasISN;
